import { render, staticRenderFns } from "./StepRejection.vue?vue&type=template&id=2f4fd1b4&"
import script from "./StepRejection.vue?vue&type=script&lang=ts&"
export * from "./StepRejection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports